import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Container, FlexWrapper, NavBar, Topper } from "./AppSkeleton.style.ts";
import { ItemsListSkeleton } from "./ItemsListSkeleton.tsx";

export const AppSkeleton = () => {
    const navWidths = [150, 100, 150, 100, 150, 150];

    return (
        <SkeletonTheme baseColor={'#e6e6e6'}
            highlightColor={'#f3f3f3'}
            duration={1.2}>
            <Container>
                <Topper>
                    <FlexWrapper>
                        <Skeleton width="35%" height={30} borderRadius={10} />
                    </FlexWrapper>
                    <Skeleton circle height={30} width={30} style={{ marginRight: '12px' }} />
                </Topper>

                <Skeleton width="35%"
                    height={40}
                    borderRadius={10}
                    style={{ margin: "28px 0" }} />

                <NavBar>
                    <Skeleton circle height={30} width={30} />
                    {navWidths.map((width, i) => (
                        <Skeleton key={i} width={width} height={30} borderRadius={10} />
                    ))}
                </NavBar>

                <ItemsListSkeleton />
            </Container>
        </SkeletonTheme>
    );
};